export default __webpack_public_path__ + "static/media/annoying-lack-of-bleeding-map.2527f004.png";